/**
 * tokens.js — BRIDGE JS
 *
 * Usado APENAS por: Konva (StorePlantEditor), Chart.js, canvas, qualquer
 * contexto que precise de cor como string JS em runtime.
 *
 * NÃO importar em componentes React normais.
 * NÃO usar em import-time — todas as funções são chamadas em runtime.
 *
 * Por que funções e não constantes?
 *   getComputedStyle lê o valor ATUAL da CSS var, respeitando o tema ativo.
 *   Se fosse constante, travaria no tema do momento do import.
 */

const css = () => getComputedStyle(document.documentElement)
const v = (name) => css().getPropertyValue(name).trim()

export const tokens = {
  // fundos
  bgBase:     () => v('--bg-base'),
  bgSurface:  () => v('--bg-surface'),
  bgOverlay:  () => v('--bg-overlay'),
  bgSidebar:  () => v('--bg-sidebar'),
  bgDeep:     () => v('--bg-deep'),

  // texto
  textPrimary:   () => v('--text-primary'),
  textSecondary: () => v('--text-secondary'),
  textMuted:     () => v('--text-muted'),

  // bordas
  border:       () => v('--border'),
  borderStrong: () => v('--border-strong'),

  // brand
  action:       () => v('--action'),
  actionSubtle: () => v('--action-subtle'),
  actionText:   () => v('--action-text'),

  // semânticas
  success:        () => v('--success'),
  successSubtle:  () => v('--success-subtle'),
  warning:        () => v('--warning'),
  warningSubtle:  () => v('--warning-subtle'),
  error:          () => v('--error'),
  errorSubtle:    () => v('--error-subtle'),

  // gradientes (string pronta para uso em canvas/Konva fillLinearGradient)
  gradientSurface: () => v('--gradient-surface'),
  gradientBrand:   () => v('--gradient-brand'),
  gradientError:   () => v('--gradient-error'),
  gradientWarning: () => v('--gradient-warning'),
  gradientSuccess: () => v('--gradient-success'),
}

// ─── Tokens estáticos de layout ───────────────────────────────────────────────
// Mantidos para compatibilidade com Sidebar.js e outros que os importam.
// Esses valores não dependem do tema — são constantes de espaçamento/tipografia.

export const spacing = {
  xs: '4px', sm: '8px', md: '12px', lg: '16px',
  xl: '20px', '2xl': '24px', '3xl': '32px', '4xl': '48px'
}

export const fontSize = {
  xs: '11px', sm: '12px', base: '14px', lg: '16px',
  xl: '18px', '2xl': '20px', '3xl': '24px', '4xl': '32px'
}

export const borderRadius = {
  sm: '4px', md: '8px', lg: '10px', xl: '12px', '2xl': '16px', full: '9999px'
}

export const transitions = {
  fast: '150ms ease', base: '200ms ease', slow: '300ms ease', all: 'all 200ms ease'
}

/**
 * Uso no StorePlantEditor (Konva):
 *
 *   import { tokens } from '../theme/tokens'
 *
 *   // dentro de um handler ou useEffect — nunca no topo do módulo
 *   node.fill(tokens.bgSurface())
 *   node.stroke(tokens.border())
 *
 * Uso no Chart.js:
 *
 *   backgroundColor: tokens.actionSubtle()
 *   borderColor:     tokens.action()
 */
